import React, { useEffect, useState } from 'react';
import './EchangesList.css';
import CommentaireForm from '../CommentaireForm/CommentaireForm';

interface Echange {
  date: string;
  heure: string;
  auteur: string | null;
  message: string;
  is_mine: boolean;
}

// Pas de titre interne : le titre de la section ("Mémo interne") est porte par le conteneur
// (SectionPliable) cote appelant, pour ne pas doubler l'en-tete.
interface EchangesListProps {
  currentUser: { id: number | null | string; name: string | null; role: string | null };
  typeElement: 'commande' | 'operation' | 'ticket';
  idElement: number;
  showCommentaireForm?: boolean;
}

const EchangesList: React.FC<EchangesListProps> = ({
  currentUser,
  typeElement,
  idElement,
  showCommentaireForm = true
}) => {
  const [echanges, setEchanges] = useState<Echange[]>([]);

  const fetchMemos = async () => {
    try {
      const token = localStorage.getItem('token');
      const queryParams = new URLSearchParams({
        type_element: typeElement,
        id_element: idElement.toString()
      });

      const response = await fetch(`${process.env.REACT_APP_API_URL}/subsequents/memo?${queryParams}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      });

      const data = await response.json();

      const memos: Echange[] = (data.memos || []).map((memo: any) => ({
        date: new Date(memo.created_at).toLocaleDateString('fr-FR'),
        heure: new Date(memo.created_at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }),
        auteur: memo.auteur_name || memo.auteur_id || 'Inconnu',
        message: memo.message,
        is_mine: memo.is_mine ?? false
      }));

      setEchanges(memos);
    } catch (error) {
      console.error('Erreur récupération mémos:', error);
    }
  };

  useEffect(() => {
    fetchMemos();
  }, [typeElement, idElement]);

  const handleNewComment = async (message: string) => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${process.env.REACT_APP_API_URL}/subsequents/memo`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        },
        body: JSON.stringify({
          type_element: typeElement,
          id_element: idElement,
          message
        })
      });

      if (res.ok) {
        fetchMemos();
      }
    } catch (error) {
      console.error('Erreur création mémo:', error);
    }
  };

  const getMessageClass = (isMine: boolean) => {
    return isMine ? 'message-user' : 'message-other';
  };

  return (
    <div className="echanges-list">
      <div className="echanges-container">
        {echanges.map((echange, index) => (
          <div
            key={index}
            className={`echange-wrapper ${echange.is_mine ? 'right' : 'left'}`}
          >
            <div className={`message-bubble ${getMessageClass(echange.is_mine)}`}>
              <p className="echange-message">{echange.message}</p>
            </div>
            <div className="echange-footer">
              <span className="echange-auteur">{echange.auteur}, </span>
              <span className="echange-date">{echange.date} à {echange.heure}</span>
            </div>
          </div>
        ))}
      </div>

      {showCommentaireForm && (
        <CommentaireForm onSubmit={handleNewComment} />
      )}
    </div>
  );
};

export default EchangesList;